import {Injectable} from '@angular/core';
import {from, Observable, of, throwError} from "rxjs";
import {catchError, map} from "rxjs/operators";
import {HttpClient, HttpParams} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {BackendService} from "./backend.service";
import {ResponseDto} from "../dto/response.dto";

@Injectable({
    providedIn: 'root'
})
export class MapService {
    private apiKey = environment.apiKeyGoogle;

  constructor(private http: HttpClient) { }

    // Método para obtener coordenadas a partir del nombre de la zona
    getCoordinatesFromName(address: string): Observable<{ lat: number; lng: number } | null> {
        const geocoder = new google.maps.Geocoder();
        const p = new Promise<{ lat: number; lng: number } | null>((resolve) => {
            geocoder.geocode({ address }, (results, status) => {
                if (status === 'OK' && results?.[0]?.geometry?.location) {
                    const loc = results[0].geometry.location;
                    resolve({ lat: loc.lat(), lng: loc.lng() });
                } else {
                    console.warn('Geocoder fail:', status, address);
                    resolve(null);
                }
            });
        });
        return from(p);
    }
    getCoordinates(address: string): Observable<{ lat: number; lng: number } | null> {
        const params = new HttpParams()
            .set('address', address)
            .set('key', this.apiKey);

        return this.http.get<any>(`https://maps.googleapis.com/maps/api/geocode/json`, { params }).pipe(
            map((response) => {
                if (response.status === 'OK' && response.results.length > 0) {
                    const location = response.results[0].geometry.location;
                    return { lat: location.lat, lng: location.lng };
                } else {
                    console.warn('No se pudo encontrar la ubicación');
                    return null; // Devolver null si no se encuentra la ubicación
                }
            }),
            catchError((error) => {
                console.error('Error en la llamada de geocodificación:', error);
                return throwError(() => new Error('Error en la llamada de geocodificación'));
            })
        );
    }
}
